import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import DateRange from 'support/displays/DateRange'

function InventoryOrderPeriodFormatter (props) {
  const [orderForStart] = useEnvValue('globals.inventory.delivery_days.order_for_start', null)
  const [orderForEnd] = useEnvValue('globals.inventory.delivery_days.order_for_end', null)

  return <DateRange defaultValue={{ from: orderForStart, to: orderForEnd }} />
}

export default InventoryOrderPeriodFormatter
